import React, { useState, lazy } from 'react';
import { MapPin, Mail } from 'lucide-react';
import { Button } from './ui/Button';
export function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    reason: '',
    description: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section className="py-16 sm:py-20 lg:py-24 bg-[#0f2424]" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="text-center mb-12 sm:mb-16" data-id="element-53">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6" data-id="element-54">
            Contact Us
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12" data-id="element-55">
          {/* Left Column - Get In Touch */}
          <div data-id="element-56">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6 sm:mb-8" data-id="element-57">
              Get In Touch
            </h3>

            <div className="space-y-5 sm:space-y-6 mb-6 sm:mb-8" data-id="element-58">
              <div className="flex items-start gap-3 sm:gap-4" data-id="element-59">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-[#4fd1c5]/10 flex items-center justify-center flex-shrink-0" data-id="element-60">
                  <MapPin className="h-5 w-5 sm:h-6 sm:w-6 text-[#4fd1c5]" data-id="element-61" />
                </div>
                <div data-id="element-62">
                  <h4 className="text-base sm:text-lg font-semibold text-white mb-1" data-id="element-63">
                    Our Location
                  </h4>
                  <p className="text-sm sm:text-base text-gray-400" data-id="element-64">
                    Orlando, FL
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4" data-id="element-65">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-[#4fd1c5]/10 flex items-center justify-center flex-shrink-0" data-id="element-66">
                  <Mail className="h-5 w-5 sm:h-6 sm:w-6 text-[#4fd1c5]" data-id="element-67" />
                </div>
                <div data-id="element-68">
                  <h4 className="text-base sm:text-lg font-semibold text-white mb-1" data-id="element-69">
                    Email
                  </h4>
                  <p className="text-sm sm:text-base text-gray-400 break-all" data-id="element-70">
                    info@laundryinvestors.com
                  </p>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-xl overflow-hidden border-4 border-[#1a3a3a] h-[300px] sm:h-[400px]" data-id="element-71">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d448193.95098418634!2d-81.64010815!3d28.538336!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e773d8fecdbc77%3A0xac3b2063ca5bf9e!2sOrlando%2C%20FL!5e0!3m2!1sen!2sus!4v1234567890" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-72"></iframe>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div className="bg-[#0b1a1a] border border-gray-800 rounded-2xl p-6 sm:p-8" data-id="element-73">
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-6" data-id="element-74">
              Send Us a Message
            </h3>

            <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6" data-id="element-75">
              <div data-id="element-76">
                <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-77">
                  Name
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-3 bg-white text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4fd1c5] text-base" required data-id="element-78" />
              </div>

              <div data-id="element-79">
                <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-80">
                  Email
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-3 bg-white text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4fd1c5] text-base" required data-id="element-81" />
              </div>

              <div data-id="element-82">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-83">
                  Phone
                </label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 bg-white text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4fd1c5] text-base" data-id="element-84" />
              </div>

              <div data-id="element-85">
                <label htmlFor="reason" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-86">
                  Reason for Inquiry
                </label>
                <select id="reason" name="reason" value={formData.reason} onChange={handleChange} className="w-full px-4 py-3 bg-white text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4fd1c5] text-base" required data-id="element-87">
                  <option value="" data-id="element-88">Select a reason</option>
                  <option value="selling" data-id="element-89">
                    I'm interested in selling my laundromat
                  </option>
                  <option value="investing" data-id="element-90">
                    I'm interested in investing in laundromats
                  </option>
                  <option value="referral" data-id="element-91">
                    I'd like to refer a laundromat for sale
                  </option>
                  <option value="other" data-id="element-92">Other</option>
                </select>
              </div>

              <div data-id="element-93">
                <label htmlFor="description" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-94">
                  Description
                </label>
                <textarea id="description" name="description" value={formData.description} onChange={handleChange} rows={6} className="w-full px-4 py-3 bg-white text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4fd1c5] resize-none text-base" required data-id="element-95"></textarea>
              </div>

              <Button type="submit" className="w-full" data-id="element-96">
                Submit Inquiry
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}